import {
  ESTRATEGIA_RETRY_PADRAO,
  FalhaHttp,
  type ClienteHttp,
  type RespostaHttp,
} from '@next/infraestrutura/http'

import type { OpcaoEmpregado } from '../catalogo-empregado.tipos'

const ENDPOINT = '/employee'
const CAMPOS = [
  'id', 'name', 'code', 'resignation', 'closing_date', 'admission', 'company',
  'funct', 'sincronizar_com_repp', 'custom_rules', 'work_hour_bank_rules',
] as const
const CAMPOS_RESPOSTA = [
  'id', 'name', 'code', 'resignation', 'closingDate', 'admission', 'company',
  'funct', 'sincronizarComRepp', 'customRules', 'workHourBankRules', 'firstWorkDay',
] as const
const ehRegistro = (valor: unknown): valor is Record<string, unknown> => (
  typeof valor === 'object' && valor !== null && !Array.isArray(valor)
)
const selecionar = (valor: unknown, campos: readonly string[]): unknown => (
  ehRegistro(valor) ? Object.fromEntries(campos.filter(campo => campo in valor).map(campo => [campo, valor[campo]])) : valor
)
const selecionarEmpregado = (valor: Record<string, unknown>): OpcaoEmpregado => {
  const item = selecionar(valor, CAMPOS_RESPOSTA) as Record<string, unknown>
  if (Array.isArray(item.company)) item.company = item.company.map(local => selecionar(local, ['id', 'name']))
  if ('customRules' in item) item.customRules = selecionar(item.customRules, ['id', 'calculoPassivo'])
  if ('workHourBankRules' in item) item.workHourBankRules = selecionar(item.workHourBankRules, ['id', 'name', 'autoCompensate', 'separarCompensacaoEAcumulo', 'mudaNomenclaturaParaCompensacaoNaFolha'])
  return item as OpcaoEmpregado
}

const criarFalhaRespostaInvalida = (
  resposta: RespostaHttp<unknown>,
): FalhaHttp => new FalhaHttp({
  tipo: 'resposta_invalida',
  servico: 'condominio',
  metodo: 'GET',
  endpoint: ENDPOINT,
  status: resposta.status,
  causa: resposta.data,
  ...(resposta.requestId ? { requestId: resposta.requestId } : {}),
})

export class ListarOpcoesEmpregadoRepositorioHttp {
  constructor(private readonly http: ClienteHttp) {}

  executar = async (
    sinal: AbortSignal,
  ): Promise<readonly OpcaoEmpregado[]> => {
    const resposta = await this.http.get<unknown>(ENDPOINT, {
      parametros: {
        fields: JSON.stringify(CAMPOS),
        active: 'false',
        fired: 'all',
        noderef: 'bulk',
        order_by: 'name',
      },
      signal: sinal,
      retry: ESTRATEGIA_RETRY_PADRAO,
    })

    if (ehRegistro(resposta.data) && 'no-data' in resposta.data) return []
    if (!ehRegistro(resposta.data) || !Array.isArray(resposta.data.success)) {
      throw criarFalhaRespostaInvalida(resposta)
    }

    return resposta.data.success.filter(ehRegistro).map(selecionarEmpregado)
  }
}
